import { render, staticRenderFns } from "./adminEditorCard.vue?vue&type=template&id=22b8174c&scoped=true&"
import script from "./adminEditorCard.vue?vue&type=script&lang=js&"
export * from "./adminEditorCard.vue?vue&type=script&lang=js&"
import style0 from "./adminEditorCard.vue?vue&type=style&index=0&id=22b8174c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8174c",
  null
  
)

export default component.exports